import {Component} from 'react';
import invert from "lodash/invert";

import {getCurrentLayout} from "../../appLayout";
import {getBvGroupFeatures, getBvGroupFilterValues} from "../../../api/server-api";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import {IS_OFFLINE_MODE, USE_SERVER_CACHING} from "../../../config";
import {
  COUNTERTOP_GROUP,
  LayoutAbbreviations,
  LayoutType as LayoutTypes
} from "../../kvComponent/core/constants";
import {setActivePartFilterValues} from "../../../misc/filtersFunctions";
import {checkIfLookFeaturesReceived, getAdditionalFeaturesOnScroll, getFeaturesPageSize} from "../../../api/look-api";
import store from "../../../store";
import {updateCanvasCount} from "../../../actions/actionFunctions";

export default class NavigationRequests extends Component {

  getBvPartFeatures = async (item, navigationItem, callBack = null) => {
    if (!item.part.createdManually && !item.part.requestInProgress) {
      const itemPart = item.part;
      const layout = itemPart && itemPart.getParent
        ? itemPart.getParent().layout || getCurrentLayout()
        : getCurrentLayout();
      let responseArray;
      if (layout.isNewLayout) {
        responseArray = await getAdditionalFeaturesOnScroll(itemPart, false);
      } else {
        const pageSize = getFeaturesPageSize(itemPart);
        const layoutAbbr = layout.getCurrentLayoutAbbreviation();
        const nextFeaturesPage = itemPart.getNextPageToLoad(layoutAbbr);
        itemPart.requestInProgress = true;
        const response = await getBvGroupFeatures(itemPart.dbName || itemPart.partName, nextFeaturesPage, pageSize);

        responseArray = Array.isArray(response) ? response : [];

        itemPart.requestInProgress = false;
        // if (location.port === '9007' || document.kvConfig.kioskMode) {
        //   console.log('response', response.data);
        // }
        itemPart.setGroupFeatures(responseArray, pageSize, true, layoutAbbr, nextFeaturesPage);
      }
      if (navigationItem) {
        this.setState({
          [navigationItem]: item,
          render: false,
          showFilterSelection: true
        }, () => {
          this.setState({
            render: true,
          });
          this.forceUpdate()
        });
      }
      if (callBack) {
        callBack()
      }
      if (this._isMounted) {
        this.forceUpdate()
      }

      return responseArray
    }
  };

  getRelatedItemFeatures = (relatedItem) => {
    return this.getBvPartFeatures({
      part: relatedItem,
      text: relatedItem.partName
    }, "");
  };

  checkIfAllFeaturesReceived = (item, navigationItem, callBack, materialsPage) => {
    if (IS_OFFLINE_MODE) {
      return false
    }
    const itemPart = item.part;
    const layout = itemPart && itemPart.getParent
      ? itemPart.getParent().layout || getCurrentLayout()
      : getCurrentLayout();
    const layoutAbbr = layout.getCurrentLayoutAbbreviation();
    if (!(layout.isNewLayout && (itemPart && (itemPart.partId === "range" || itemPart.partId === "stove")))
      && (!itemPart.allFeaturesReceived || (itemPart.nextFeaturesPageToLoadArray && !itemPart.nextFeaturesPageToLoadArray[layoutAbbr].page))) {
      this.getBvPartFeatures(item, navigationItem, callBack);
    }
    if (layout.isNewLayout) {
      checkIfLookFeaturesReceived(itemPart, true).then(() => {
        if (materialsPage) {
          if (this._isMounted) {
            this.forceUpdate()
          }
        } else {
          callBack ? callBack() : this.forceUpdate();
        }
      }); // it has all needed feature groups already there
    }
    const showerParent = layout.parts["Shower"];
    const wallParent = layout.parts["Walls"];
    const showerComboParent = layout.parts["Shower Tub Combo"];
    const cabinetParent = layout.parts["Cabinet"];
    const centerIslandParent = layout.parts["CenterIsland"];
    const countertopParent = layout.parts["Countertop"];
    const applianceParent = layout.parts["Appliances"];

    if (this.isWallItem(itemPart)) {
      wallParent.relatedItems.forEach(relatedItem => {
        if (relatedItem.partId !== itemPart.partId && !relatedItem.allFeaturesReceived) {
          this.getRelatedItemFeatures(relatedItem);
        }
      });
    } else if (itemPart.partId === "vanity_cabinet") {
      const vanityParent = itemPart.getParent();
      vanityParent.relatedItems.forEach(relatedItem => {
        if (relatedItem.partId !== itemPart.partId && !relatedItem.allFeaturesReceived) {
          this.getRelatedItemFeatures(relatedItem);
        }
      });
      if (!layout.isNewLayout) {
        const navItem = {
          part: showerParent.showerBody,
          text: showerParent.showerBody.partName
        };
        this.checkIfAllFeaturesReceived(navItem, "");
        if (wallParent.vanityAccent && !wallParent.vanityAccent.allFeaturesReceived) {
          this.getRelatedItemFeatures(wallParent.vanityAccent);
        }
      }
    } else if (itemPart.partId === "shower_door") {
      if (showerParent && showerParent.showerDoorHandle && !showerParent.showerDoorHandle.allFeaturesReceived) {
        this.getRelatedItemFeatures(showerParent.showerDoorHandle);
      }
    } else if (itemPart.partId === "top_cabinet") { /*** KITCHEN TOP CABINETS REQUIRE CROWN_MOLDING AND HOOD AND HANDLES AND CABINETS***/
      if (cabinetParent && cabinetParent.crownMolding && !cabinetParent.crownMolding.allFeaturesReceived) {
        this.getRelatedItemFeatures(cabinetParent.crownMolding);
      }
      if (cabinetParent && cabinetParent.topHandle && !cabinetParent.topHandle.allFeaturesReceived) {
        this.getRelatedItemFeatures(cabinetParent.topHandle);
      }
      if (cabinetParent && cabinetParent.bottomCabinet && !cabinetParent.bottomCabinet.allFeaturesReceived) {
        this.getRelatedItemFeatures(cabinetParent.bottomCabinet);
      }
      if (centerIslandParent && centerIslandParent.cabinet && !centerIslandParent.cabinet.allFeaturesReceived) {
        this.getRelatedItemFeatures(centerIslandParent.cabinet);
      }
      if (applianceParent && applianceParent.hood && !applianceParent.hood.allFeaturesReceived) {
        this.getRelatedItemFeatures(applianceParent.hood);
      }
    } else if (itemPart.partId === "bottom_cabinet") { /*** KITCHEN BOTTOM CABINETS REQUIRE TOP CABINETS & CENTER ISLAND ***/
      if (cabinetParent && cabinetParent.topCabinet && !cabinetParent.topCabinet.allFeaturesReceived) {
        this.getRelatedItemFeatures(cabinetParent.topCabinet);
      }
      if (centerIslandParent && centerIslandParent.cabinet && !centerIslandParent.cabinet.allFeaturesReceived) {
        this.getRelatedItemFeatures(centerIslandParent.cabinet);
      }
      if (cabinetParent && cabinetParent.bottomHandle && !cabinetParent.bottomHandle.allFeaturesReceived) {
        this.getRelatedItemFeatures(cabinetParent.bottomHandle);
      }
    } else if (itemPart.partId === "center_island_cabinet") { /*** KITCHEN CENTER ISLAND CABINETS REQUIRE TOP CABINETS & BOTTOM CABINETS***/
      if (cabinetParent && cabinetParent.topCabinet && !cabinetParent.topCabinet.allFeaturesReceived) {
        this.getRelatedItemFeatures(cabinetParent.topCabinet);
      }
      if (cabinetParent && cabinetParent.bottomCabinet && !cabinetParent.bottomCabinet.allFeaturesReceived) {
        this.getRelatedItemFeatures(cabinetParent.bottomCabinet);
      }
    } else if (itemPart.partId === "countertop") {
      if (centerIslandParent && centerIslandParent.countertop && !centerIslandParent.countertop.allFeaturesReceived) {
        this.getRelatedItemFeatures(centerIslandParent.countertop);
      }
      if (wallParent && wallParent.backsplash && !wallParent.backsplash.allFeaturesReceived) {
        this.getRelatedItemFeatures(wallParent.backsplash);
      }
    } else if (itemPart.partId === "center_island_countertop") {
      if (countertopParent && countertopParent.countertop && (!countertopParent.countertop.allFeaturesReceived
        || !(centerIslandParent.countertop && !centerIslandParent.countertop.allFeaturesReceived))) {
        this.getRelatedItemFeatures(countertopParent.countertop);
      }
      if (wallParent && wallParent.backsplash && !wallParent.backsplash.allFeaturesReceived) {
        this.getRelatedItemFeatures(wallParent.backsplash);
      }
    } else if (itemPart.partId === "backsplash") {
      if (countertopParent && countertopParent.countertop && !countertopParent.countertop.allFeaturesReceived) {
        this.getRelatedItemFeatures(countertopParent.countertop);
      }
      if (centerIslandParent && centerIslandParent.countertop && !centerIslandParent.countertop.allFeaturesReceived) {
        this.getRelatedItemFeatures(centerIslandParent.countertop);
      }
    } else if (itemPart.partId === "edge_profile") {
      if (countertopParent && countertopParent.countertop && !countertopParent.countertop.allFeaturesReceived) {
        this.getRelatedItemFeatures(countertopParent.countertop);
      }
    } else if (itemPart.partId === "center_island_edge") {
      if (centerIslandParent && centerIslandParent.countertop && !centerIslandParent.countertop.allFeaturesReceived) {
        this.getRelatedItemFeatures(centerIslandParent.countertop);
      }
    } else if (itemPart.partId === "microwave" || itemPart.partId === "hood") { /*** KITCHEN APPLIANCE REQUIRE TOP CABINETS ***/
      if (cabinetParent && cabinetParent.topCabinet && !cabinetParent.topCabinet.allFeaturesReceived) {
        this.getRelatedItemFeatures(cabinetParent.topCabinet);
      }
    } else if (itemPart.createdManually) {  // shower_body || wall_configuration
      const neededParts = ["pony_wall", "left_shower_wall", "right_shower_wall"];
      if (callBack) {
        neededParts.push("wall_c");
      }
      const getData = async () => {
        return await Promise.all([...showerParent.relatedItems.map(async relatedItem => {
          if (relatedItem.partId !== itemPart.partId && !relatedItem.allFeaturesReceived) {
            return await this.getRelatedItemFeatures(relatedItem)
          }
        }), ...wallParent.relatedItems.map(async relatedItem => {
          if (neededParts.includes(relatedItem.partId) && !relatedItem.allFeaturesReceived) {
            return await this.getRelatedItemFeatures(relatedItem);
          }
        })])
      };
      getData() // after we receive all shower related items we can switch shower body
        .then(() => {
          showerParent.showerBody.allFeaturesReceived = true;
          showerComboParent.wallConfiguration.allFeaturesReceived = true;
          if (materialsPage) {
            if (this._isMounted) {
              this.forceUpdate()
            }
          } else {
            callBack ? callBack() : this.forceUpdate();
          }
        });
    }
  };

  checkIfAllFiltersReceived = (activeSubPart, allFilterGroups) => {
    return getBvGroupFilterValues(activeSubPart.dbName || activeSubPart.partName)
      .then((response) => {
        setActivePartFilterValues(response.data, activeSubPart, allFilterGroups);
        return true
      });
  };

  isWallItem = (itemPart) => {
    let wallsPartIds = [];
    switch(document.kvConfig.visualizerType) {
      case "Bathroom":
      case "BV":
        wallsPartIds = ["wall_a", "wall_b", "wall_c", "right_shower_wall", "left_shower_wall","pony_wall"];
        break;
      case "Kitchen":
        wallsPartIds = ["left_wall", "right_wall", "popout_wall"];
        break;
      case "kvScene":
        wallsPartIds = ["left_wall", "right_wall", "center_wall", "front_wall", "popout_wall"];
        break;
      case "bvScene":
      case "bvLook":
        wallsPartIds = ["left_wall", "right_wall", "center_wall", "shower_interior_wall"];
        break;
      default:
        wallsPartIds = ["left_wall", "right_wall", "center_wall"];
    }
    return wallsPartIds.includes(itemPart.partId);
  };

  static searchFeaturesByName = (relatedItem, searchName, pageSize = 9999) => {
    if (Array.isArray(relatedItem.alreadyRequestedFeatureNames)
      && relatedItem.alreadyRequestedFeatureNames.includes(searchName)) {
      return Promise.resolve()
    }
    const dbName = relatedItem.dbName || relatedItem.partName;
    return getBvGroupFeatures(dbName, 0, pageSize, [], searchName)
      .then(response => {
        if (response && response.length) {
          relatedItem.setGroupFeatures(response, 0, false);
          if (!relatedItem.alreadyRequestedFeatureNames) {
            relatedItem.alreadyRequestedFeatureNames = [];
          }
          if (searchName) {
            relatedItem.alreadyRequestedFeatureNames.push(searchName);
          }
        }
        return response
      })
  };

  changeLayout = (layoutType, firstChange = false) => {
    if (!firstChange) {
      loaderEnable();
    }
    window.requestInProcess = true;
    const layout = getCurrentLayout();
    switch (document.kvConfig.visualizerType) {
      case "Kitchen":
      case "KV": {
        const cabinetParent = layout.parts["Cabinet"];
        const applianceParent = layout.parts["Appliances"];
        const wallsParent = layout.parts["Walls"];
        const countertopParent = layout.parts["Countertop"];
        const neededParts = ["left_wall", "fridge", "top_cabinet", "top_handle", "bottom_cabinet", "bottom_handle",
          "popout_wall", "backsplash", "countertop"];
        let relatedArray = [];
        [cabinetParent, applianceParent, wallsParent, countertopParent].forEach(parent => {
          if (parent) {
            relatedArray = [...relatedArray, ...parent.relatedItems]
          }
        });
        relatedArray = relatedArray.filter((relatedItem) => {
          return neededParts.includes(relatedItem.partId) && !relatedItem.allFeaturesReceived
        });
        const countertopPageChanges = this.getSubPartLayoutPageChanges(countertopParent, "countertop", layoutType);
        const backsplashPageChanges = this.getSubPartLayoutPageChanges(wallsParent, "backsplash", layoutType);
        if (relatedArray.length
          || countertopPageChanges.requestNeeded
          || countertopPageChanges.requestNameNeeded
          || backsplashPageChanges.requestNeeded
          || backsplashPageChanges.requestNameNeeded
        ) {
          return this.getNeeededKvPartsOnLayoutChange(layoutType, relatedArray, [countertopPageChanges, backsplashPageChanges], firstChange);
        } else {
          this.finishChangeLayout(layoutType);
        }
        break;
      }
      // case "kvScene": {
      case "bvScene": {
        this.getBvSceneParts(layoutType);
        break;
      }
      case "Bathroom":
      case "BV": {
        const showerParent = layout.parts["Shower"];
        if (showerParent && showerParent.showerBody && !showerParent.showerBody.allFeaturesReceived) {
          const navItem = {
            part: showerParent.showerBody,
            text: showerParent.showerBody.partName
          };
          const oldType = layout.type;
          layout.type = layoutType;
          this.forceUpdate();
          this.checkIfAllFeaturesReceived(navItem, "", () => {
            this.finishChangeLayout(layoutType, oldType);
          });
        } else {
          this.finishChangeLayout(layoutType);
        }
        break;
      }
      default:
        this.finishChangeLayout(layoutType, null, null, firstChange);
        break;
    }
  };

  finishChangeLayout = (layoutType, oldType, currentState, firstChange = false) => {
    const layout = getCurrentLayout();
    if (Number.isInteger(oldType)) {
      loaderEnable();
      layout.type = oldType;
      layout.selectLayout(layoutType, oldType, currentState);
    } else {
      layout.selectLayout(layoutType);
    }
    window.requestInProcess = false;
    if (!layout.initialized && !firstChange) {
      layout.initialized = true;
    }
    if (this.props.refreshCB && !firstChange) {
      this.props.refreshCB();
    }
    if (!firstChange) {
      this.forceUpdate();
      store.dispatch(updateCanvasCount()); // update canvas
      loaderDisable();
    }
    return true
  };

  getBvSceneParts = (layoutType) => {
    const layout = getCurrentLayout();
    const wallsParent = layout.parts["Walls"];
    const showerParent = layout.parts["Shower"];
    const neededParts = ["left_wall", "right_wall", "shower_interior_wall", "shower_fixture"];
    let promises = [];
    [wallsParent, showerParent].forEach(parent => {
      if (parent && parent.relatedItems) {
        parent.relatedItems.forEach(relatedItem => {
          if (neededParts.includes(relatedItem.partId) && !relatedItem.allFeaturesReceived) {
            promises.push(this.getRelatedItemFeatures(relatedItem))
          }
        })
      }
    })
    const oldType = layout.type;
    layout.type = layoutType;
    Promise.all(promises).then(() => this.finishChangeLayout(layoutType, oldType))
  };

  getSubPartLayoutPageChanges = (parent, childName, layoutType) => {
    let
      requestNeeded = false,
      requestNameNeeded = false,
      nextLayoutFeaturesPage = 0,
      maxCurrentFeaturesPage = 0;
    if (parent && parent[childName]) {
      if (USE_SERVER_CACHING && parent[childName].nextFeaturesPageToLoadArray) {
        maxCurrentFeaturesPage = Math.max(...Object.values(parent[childName].nextFeaturesPageToLoadArray).map(obj => obj.page))
        nextLayoutFeaturesPage = (parent[childName].nextFeaturesPageToLoadArray[LayoutAbbreviations[layoutType]]).page;
        if (nextLayoutFeaturesPage < maxCurrentFeaturesPage) {
          requestNeeded = true;
        }
      }
      if (parent[childName].activeFeature) {
        const currentActiveName = parent[childName].activeFeature.getSplittedFeatureName();
        const neededLayoutName = invert(LayoutTypes)[layoutType];
        const neededFeature = parent[childName].featuresList[neededLayoutName].find((feature) => {
          const featureName = feature.getSplittedFeatureName();
          return featureName && currentActiveName && (featureName === currentActiveName)
        });
        if (!neededFeature) {
          requestNameNeeded = currentActiveName.split(" ")[0]
        }
      }
    }
    return {
      requestNeeded,
      requestNameNeeded,
      nextLayoutFeaturesPage,
      maxCurrentFeaturesPage,
      relatedItem: parent ? parent[childName] : null
    }
  };

  getNeeededKvPartsOnLayoutChange = (layoutType, relatedPartsToReceive, relatedPartsToReceiveForLayouts, firstChange = false) => {
    const layout = getCurrentLayout();
    const currentState = layout.getActiveFeaturesAsObject(true, false, true);
    const oldType = layout.type;
    layout.type = layoutType;
    if (!firstChange) {
      this.forceUpdate();
    }
    const promises = relatedPartsToReceive.map((relatedItem) => {
      const size = COUNTERTOP_GROUP.includes(relatedItem.partId) ? 2000 : 1000;
      return getBvGroupFeatures(relatedItem.dbName || relatedItem.partName, 0, size).then(response => {
        relatedItem.setGroupFeatures(Array.isArray(response) ? response : [], size);
        return response
      })
    });
    relatedPartsToReceiveForLayouts.forEach((pageChanges) => {
      if (pageChanges.requestNeeded) { // here we receive all the same features for new layout type (cause client already received them in another layout)
        const nextLayoutName = LayoutAbbreviations[layoutType];
        const featuresSize = 1000 * (pageChanges.maxCurrentFeaturesPage - pageChanges.nextLayoutFeaturesPage);
        promises.push(getBvGroupFeatures(pageChanges.relatedItem.partName, pageChanges.nextLayoutFeaturesPage, featuresSize, [], "", nextLayoutName)
          .then(response => {
            pageChanges.relatedItem.nextFeaturesPageToLoadArray[nextLayoutName].page = pageChanges.maxCurrentFeaturesPage - 1; // 1 will be added in setGroupFeatures method
            pageChanges.relatedItem.setGroupFeatures(Array.isArray(response) ? response : []);
            return response
          }))
      }
      if (pageChanges.requestNameNeeded) { // here we receive current active itm to set it
        promises.push(NavigationRequests.searchFeaturesByName(pageChanges.relatedItem, pageChanges.requestNameNeeded))
      }
    });
    return Promise.all(promises).then(() => this.finishChangeLayout(layoutType, oldType, currentState, firstChange));
  };

}
